const getElementY = (element, offset = 0) => {
  const elementViewportOffset = element ? element.getBoundingClientRect().top : 0
  return window.pageYOffset + elementViewportOffset + offset
}

const smoothScrollTo = (element, duration, offset = 0, done) => {
  if (!document.querySelector || !window.requestAnimationFrame) {
    window.location.href = element
    done && done()
    return
  }

  if (typeof element === 'string') {
    return smoothScrollTo(document.querySelector(element), duration, offset, done)
  }

  duration = duration || 300

  const startingY = window.pageYOffset
  const elementY = getElementY(element, offset)

  const targetY =
    document.body.scrollHeight - elementY < window.innerHeight
      ? document.body.scrollHeight - window.innerHeight
      : elementY
  const diff = targetY - startingY

  const easing = (t) => {
    return t * (2 - t)
  }

  // eslint-disable-next-line no-void
  let start = void 0

  if (!diff) {
    done && done()
    return
  }

  const step = (timestamp) => {
    if (!start) start = timestamp

    const time = timestamp - start
    let percent = Math.min(time / duration, 1)
    percent = easing(percent)

    window.scrollTo(0, startingY + diff * percent)

    if (time < duration) {
      window.requestAnimationFrame(step)
    } else {
      done && done()
    }
  }

  window.requestAnimationFrame(step)
}

export default smoothScrollTo
